@for (quickscanCategory of quickscanDefinition?.categories; track trackQuickscanCategory(quickscanCategoryIndex, quickscanCategory); let quickscanCategoryIndex = $index) {
  <div class="prevent-pagebreak-inside">
    <vwui-table [compactable]="false">
      <div slot="table-title">{{ quickscanCategoryIndex + 1 }}. {{ quickscanCategory.name }}</div>
      <vwui-table-row>
        <vwui-table-header class="table-col table-col--nr">{{ 'PAGE_FILL_QUICKSCAN.table.column.nr' | translate }}</vwui-table-header>
        <vwui-table-header class="table-col table-col--question">{{ 'PAGE_FILL_QUICKSCAN.table.column.question' | translate }}</vwui-table-header>
        <vwui-table-header class="table-col table-col--answer-and-remark">{{ 'PAGE_FILL_QUICKSCAN.table.column.answer' | translate }}</vwui-table-header>
        <vwui-table-header class="table-col table-col--score">{{ 'PAGE_FILL_QUICKSCAN.table.column.score' | translate }}</vwui-table-header>
      </vwui-table-row>
      @for (quickscanQuestion of quickscanCategory | categoryGetAllSubCategoryQuestions | async; track trackQuickscanCategoryQuestion(quickscanQuestionIndex, quickscanQuestion); let quickscanQuestionIndex = $index) {
        <vwui-table-row>
          <vwui-table-column class="table-col table-col--nr">{{ quickscanCategoryIndex + 1 }}.{{ quickscanQuestionIndex + 1 }}</vwui-table-column>
          <vwui-table-column class="table-col table-col--question">
            <div class="pdf-page__project-subtitle">
              {{ quickscanQuestion.getCategoryName() }}
              @if (hasRedFlagForQuestion(quickscanQuestion)) {
                <vwui-icon class="red-flag" iconName="flag"></vwui-icon>
              }
              @if (canHaveRedFlagForQuestion(quickscanQuestion) && !hasRedFlagForQuestion(quickscanQuestion)) {
                <vwui-icon class="flag-outline" iconName="flag-outline"></vwui-icon>
              }
            </div>
            <div>{{ quickscanQuestion.name }}</div>
            @if (quickscanQuestion.info) {
              <small class="pdf-page__project-note"><vwui-icon iconName="info"></vwui-icon>{{ quickscanQuestion.info }}</small>
            }
            @if (hasQuickscanQuestionRemark(quickscanQuestion)) {
              <small class="pdf-page__project-note"><vwui-icon iconName="chat"></vwui-icon>{{ getQuickscanQuestionRemark(quickscanQuestion) }}</small>
            }
          </vwui-table-column>
          <vwui-table-column class="table-col table-col--answer-and-remark">{{ getQuickscanQuestionAnswer(quickscanQuestion) }}</vwui-table-column>
          <vwui-table-column class="table-col table-col--score">{{ getWeightedScoreForQuestion(quickscanQuestion, quickscanCategory) }}</vwui-table-column>
        </vwui-table-row>
      }
      <vwui-table-row>
        <vwui-table-column class="table-col table-col--nr"></vwui-table-column>
        <vwui-table-column class="table-col table-col--question">
          @if (hasQuickscanCategoryRemark(quickscanCategory)) {
            <small class="pdf-page__project-note pdf-page__project-note--bottom"><vwui-icon iconName="chat"></vwui-icon>{{ getQuickscanCategoryRemark(quickscanCategory) }}</small>
          }
        </vwui-table-column>
        <vwui-table-column class="table-col table-col--answer-and-remark">
          @if (quickscanCategory.type === 'risk') {
            <vwui-badge class="badge" [ngClass]="{'badge--red': getIndicatorForCategory(quickscanCategory) === 'red', 'badge--green': getIndicatorForCategory(quickscanCategory) === 'green'}"> {{ 'CLASSIFICATION.' + getIndicatorForCategory(quickscanCategory) | translate }} </vwui-badge>
            <vwui-badge class="badge">{{ getRedFlagsForCategory(quickscanCategory) }}</vwui-badge>
          }
        </vwui-table-column>
        <vwui-table-column class="table-col table-col--score">{{ getWeightedScoreForCategory(quickscanCategory) }}</vwui-table-column>
      </vwui-table-row>
    </vwui-table>
    <div class="grid-spacer grid-spacer--large"></div>
  </div>
}
